const hy = {
  info1: `Այստեղ կարող եք ներկայացնել ձեր հարցը՝ UXCG-ին ավելացնելու համար։`,
  info2: `Հարցը պետք է լինի ընդհանուր բնույթի, չկրկնի առկա հարցերից որևէ մեկին և անդրադառնա կարևոր, ընդհանուր խնդրի։`,
  info3: `Շնորհակալություն:`,
  questionLabel: 'Ձեր հարցը',
  questionError: `Դաշտը պարտադիր է`,
  tagsLabel: 'Առաջարկվող թեգեր',
  nameLabel: 'Ձեր անունը',
  namePlaceholder: 'Անուն',
  //TODO -  Armenian is missing!
  nameHint:
    'Please use your real name or nickname. It will be shown in the question pop-up in case of its adding to the project.',
  emailLabel: 'Ձեր էլ. հասցեն',
  emailPlaceholder: 'Էլ. փոստ',
  emailError: `Սխալ էլ. հասցե`,
  cancelButtonLabel: `Չեղարկել`,
  submitButtonLabel: `Հաստատել`,
};

export default hy;
